import React, {
  InputHTMLAttributes,
  ReactNode,
  Ref,
  forwardRef,
  useState,
} from 'react';
import { cn } from '../../../utils';

type NumberInputProps = Omit<
  InputHTMLAttributes<Omit<HTMLInputElement, 'type'>>,
  'prefix'
> & {
  prefix?: ReactNode;
  suffix?: ReactNode;
  extraClassname?: string;
};

export const NumberInput = forwardRef(
  (props: NumberInputProps, ref: Ref<HTMLInputElement>) => {
    const [isFocused, setIsFocused] = useState(false);

    const { extraClassname, prefix, suffix, ...rest } = props;

    return (
      <div className="flex flex-row w-full !text-sm">
        {prefix && (
          <span
            className={cn(
              'font-semibold !inline-flex !border-evolve-primary !border-2 !border-r-0 items-center px-2',
              { '!border-evolve-highlight-50': isFocused }
            )}
          >
            {prefix}
          </span>
        )}
        <input
          {...rest}
          ref={ref}
          type="number"
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className={cn(
            '!border-evolve-primary !border-2 !p-2 focus-visible:!border-evolve-highlight-50 focus-visible:!outline-none',
            { '!border-l-0': prefix },
            { '!border-r-0': suffix },
            extraClassname
          )}
        />
        {suffix && (
          <span
            className={cn(
              'font-semibold !inline-flex !border-evolve-primary !border-2 !border-l-0 items-center px-2',
              { '!border-evolve-highlight-50': isFocused }
            )}
          >
            {suffix}
          </span>
        )}
      </div>
    );
  }
);

NumberInput.displayName = 'NumberInput';
